<template>
    <Modal id="debug-modal"
           icon="fa-tools"
           cancel-label="CLOSE"
           :cancel="cancel"
           title="DEBUG_MODAL.MODAL_TITLE"
           size="lg">
        <div class="about">
            <div>
                <DebugPrintingSection />
                <DebugAgentSection />
            </div>

            <div>
                <DebugStorageSection />
            </div>

            <div>
                <DebugMiscSection @close="resolve" />
            </div>
        </div>
    </Modal>
</template>

<script>
import DebugAgentSection from '@/epos/vue/modals/Debug/DebugAgentSection';
import DebugMiscSection from '@/epos/vue/modals/Debug/DebugMiscSection';
import DebugPrintingSection from '@/epos/vue/modals/Debug/DebugPrintingSection';
import DebugStorageSection from '@/epos/vue/modals/Debug/DebugStorageSection';
import Modal from '@/vue/components/Modals/Modal';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    components: {
        Modal,
        DebugMiscSection,
        DebugAgentSection,
        DebugPrintingSection,
        DebugStorageSection,
    },

    mixins: [
        ModalPropsMixin,
    ],
};

</script>

<style lang="less">
@import "../About/about";
</style>
